import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {error: null, errorInfo: null};
  }

  componentDidCatch(error, errorInfo) {
    this.setState({error, errorInfo});
  }

  render() {
    const {error, errorInfo} = this.state;

    if (errorInfo) {
      return (
        <div>
          <h1>Something went wrong</h1>
          {process.env.NODE_ENV !== 'production' && (
            <details style={{whiteSpace: 'pre-wrap'}}>
              <summary>{String(error)}</summary>
              <pre>
                <code>{errorInfo.componentStack}</code>
              </pre>
            </details>
          )}
        </div>
      );
    }

    const {children} = this.props;
    return children;
  }
}

export default ErrorBoundary;
